export function convertPicksToPixels(pixels: number, nrPicksPerColorLine: number): number {
  return nrPicksPerColorLine > 0 ? Math.round(pixels / nrPicksPerColorLine) : pixels;
}
